export const formatTIN = (value: string): string => {
    if (!value) return value;
    const tin = value.replace(/[^\d]/g, ''); // strip non-digits
    const tinLength = tin.length;

    if (tinLength <= 3) return tin;
    if (tinLength <= 6) return `${tin.slice(0, 3)}-${tin.slice(3, 6)}`;
    if (tinLength <= 9) return `${tin.slice(0, 3)}-${tin.slice(3, 6)}-${tin.slice(6, 9)}`;
    return `${tin.slice(0, 3)}-${tin.slice(3, 6)}-${tin.slice(6, 9)}-${tin.slice(9, 12)}`;

}